// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","764":"48ef9f6e","838":"6324e6a8"}[chunkId] + ".chunk.js";
};